import { SitePhotoTypeKey } from "../models/globalTypes";

const getSitePhotoTypeColor = (type: string) => {
  switch (type) {
    case SitePhotoTypeKey.ISSUE:
      return "olive";
    case SitePhotoTypeKey.PREPARATION:
      return "yellow";
    case SitePhotoTypeKey.WORK_PROGRESS:
      return "teal";
    default:
      return "grey";
  }
};

export { getSitePhotoTypeColor };
